<template>
    <validation-observer ref="refForm">

        <b-form @submit.prevent="onSubmit">

            <b-row>
                <b-col md="12">
                    <b-card footer-tag="footer">

                        <b-row>

                            <b-col cols="12">
                                <b-alert variant="info" :show="true">
                                    <div class="alert-body">
                                        <span v-if="!fieldsUnlocked">
                                            Pegue el enlace de la noticia y presione <strong>Traer datos</strong>.
                                            Se completarán el título, la descripción y la imagen desde el sitio original;
                                            luego podrá editarlos.
                                        </span>
                                        <span v-else>
                                            Revise y ajuste los datos si hace falta. Así se verá la tarjeta en la web.
                                        </span>
                                    </div>
                                </b-alert>
                            </b-col>

                            <!-- URL -->
                            <b-col cols="12">
                                <b-form-group label-for="url">
                                    <template #label>
                                        <strong>ENLACE DE LA NOTICIA</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="enlace"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                id="url"
                                                v-model="formData.url"
                                                placeholder="https://..."
                                                :state="errors.length > 0 ? false : null"
                                                trim
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    variant="outline-primary"
                                                    :disabled="fetching || !formData.url"
                                                    @click="fetchPreview"
                                                >
                                                    <b-spinner small v-if="fetching" />
                                                    <template v-else>
                                                        <feather-icon icon="SearchIcon" size="16" class="mr-50" />
                                                        <span>Traer datos</span>
                                                    </template>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="text-muted" v-if="!fieldsUnlocked">
                                        El resto de campos se habilita al traer los datos.
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- TITLE -->
                            <b-col cols="12" md="8">
                                <b-form-group label-for="title">
                                    <template #label>
                                        <strong>TÍTULO</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="título"
                                    >
                                        <b-form-input
                                            id="title"
                                            v-model="formData.title"
                                            :disabled="!fieldsUnlocked"
                                            placeholder="Título de la noticia ..."
                                            maxlength="250"
                                            :state="errors.length > 0 ? false : null"
                                            trim
                                        />
                                        <small class="textarea-counter-value float-right">
                                            <strong class="char-count">{{ formData.title ? formData.title.length : 0 }} / 250</strong>
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- SOURCE -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="source">
                                    <template #label>
                                        <strong>MEDIO</strong>
                                    </template>
                                    <b-form-input
                                        id="source"
                                        v-model="formData.source"
                                        :disabled="!fieldsUnlocked"
                                        placeholder="El Comercio, BBC ..."
                                        maxlength="120"
                                        trim
                                    />
                                    <small class="textarea-counter-value float-right">
                                        <strong class="char-count">{{ formData.source ? formData.source.length : 0 }} / 120</strong>
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- DESCRIPTION -->
                            <b-col cols="12">
                                <b-form-group label-for="description">
                                    <template #label>
                                        <strong>DESCRIPCIÓN</strong>
                                    </template>
                                    <b-form-textarea
                                        id="description"
                                        v-model="formData.description"
                                        :disabled="!fieldsUnlocked"
                                        placeholder="Resumen que se verá en la tarjeta ..."
                                        rows="3"
                                        maxlength="400"
                                    />
                                    <small class="textarea-counter-value float-right">
                                        <strong class="char-count">{{ formData.description ? formData.description.length : 0 }} / 400</strong>
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- IMAGE URL -->
                            <b-col cols="12">
                                <b-form-group label-for="image_url">
                                    <template #label>
                                        <strong>IMAGEN (URL)</strong>
                                    </template>
                                    <b-form-input
                                        id="image_url"
                                        v-model="formData.image_url"
                                        :disabled="!fieldsUnlocked"
                                        placeholder="https://... (opcional)"
                                        trim
                                    />
                                    <small class="text-muted">
                                        Se usa la imagen del sitio original. Si el medio la elimina, la tarjeta se muestra sin imagen.
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- PREVIEW -->
                            <b-col cols="12" v-if="formData.title">
                                <p class="mb-50"><strong>VISTA PREVIA</strong></p>
                                <b-card class="border mb-2" no-body>
                                    <div class="d-flex">
                                        <b-img
                                            v-if="formData.image_url"
                                            :src="formData.image_url"
                                            width="140"
                                            height="100"
                                            style="object-fit: cover; border-radius: .357rem 0 0 .357rem;"
                                            alt="portada"
                                        />
                                        <div class="p-1">
                                            <small class="text-muted">{{ formData.source }}</small>
                                            <h6 class="mb-25">{{ formData.title }}</h6>
                                            <small>{{ formData.description }}</small>
                                        </div>
                                    </div>
                                </b-card>
                            </b-col>

                            <!-- PUBLISHED AT -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="published_at">
                                    <template #label>
                                        <strong>FECHA DE PUBLICACIÓN</strong>
                                    </template>
                                    <flat-pickr
                                        id="published_at"
                                        v-model="formData.published_at"
                                        class="form-control"
                                        :disabled="!fieldsUnlocked"
                                        :config="dateConfig"
                                        placeholder="YYYY-MM-DD"
                                    />
                                    <small class="text-muted">Es la fecha en que el medio publicó la nota, no la de hoy. Se completa sola al traer los datos del enlace, cuando el medio la expone. Si queda vacía, la web no muestra fecha.</small>
                                </b-form-group>
                            </b-col>

                            <!-- ORDER -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="display_order">
                                    <template #label>
                                        <strong>ORDEN EN LA WEB</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="integer"
                                        name="orden"
                                    >
                                        <b-form-input
                                            id="display_order"
                                            v-model="formData.display_order"
                                            :disabled="!fieldsUnlocked"
                                            type="number"
                                            min="0"
                                            placeholder="Vacío = al final ..."
                                            :state="errors.length > 0 ? false : null"
                                            trim
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="text-muted">Define la posición en la que aparece en la página pública. El menor número va primero. Si el número ya está en uso, los demás se recorren automáticamente. Si lo dejas vacío, se muestra después de los que sí tienen orden, alfabéticamente por título.</small>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <template #footer>
                            <b-button-loading
                                text="AGREGAR"
                                type="submit"
                                :processing="processing"
                                :disabled="!fieldsUnlocked">
                            </b-button-loading>

                            <b-button
                                variant="outline-secondary"
                                class="ml-1"
                                :to="{ name: 'news' }"
                            >
                                CANCELAR
                            </b-button>
                        </template>

                    </b-card>
                </b-col>
            </b-row>

        </b-form>

    </validation-observer>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import BButtonLoading from '@core/components/b-button-loading/BButtonLoading.vue';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { useToast } from 'vue-toastification/composition';
    import { ref, onUnmounted } from '@vue/composition-api';
    import { Spanish } from 'flatpickr/dist/l10n/es';
    import flatPickr from 'vue-flatpickr-component';
    import newsStoreModule from '../newsStoreModule';
    import Ripple from 'vue-ripple-directive';
    import { required } from '@validations';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            BButtonLoading,
            flatPickr,
            required
        },
        directives: {
            Ripple
        },
        setup() {

            const toast = useToast();

            const processing = ref(false);
            const fetching = ref(false);
            const refForm = ref(null);

            // Sin hora: de la fecha de publicación solo interesa el día.
            const dateConfig = { enableTime: false, locale: Spanish };

            // El formulario arranca con todo bloqueado salvo el enlace, para que
            // quede claro que el primer paso es pegar la URL y traer los datos.
            const fieldsUnlocked = ref(false);

            const unlockFields = () => {
                fieldsUnlocked.value = true;
            };

            const formData = ref({
                url: null,
                title: null,
                description: null,
                image_url: null,
                source: null,
                published_at: null,
                display_order: null
            });

            const NEWS_APP_STORE_MODULE_NAME = 'app-news';

            if (!store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.registerModule(NEWS_APP_STORE_MODULE_NAME, newsStoreModule);

            onUnmounted(() => {
                if (store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.unregisterModule(NEWS_APP_STORE_MODULE_NAME);
            });

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const fetchPreview = () => {

                if (!formData.value.url) return;

                fetching.value = true;

                store.dispatch('app-news/fetchLinkPreview', { url: formData.value.url })
                    .then(response => {

                        const { success, preview, message } = response.data;

                        if (!success) {
                            // El medio no se dejó leer (bloquea bots, está caído...).
                            // Se desbloquean igual los campos: si no, el usuario
                            // quedaría atrapado sin poder cargar la noticia.
                            showToast(message, 'AlertTriangleIcon', 'warning');
                            unlockFields();
                            fetching.value = false;
                            return;
                        }

                        // Solo se rellena lo que esté vacío: no se pisa lo que el
                        // usuario ya escribió a mano.
                        if (!formData.value.title) formData.value.title = preview.title;
                        if (!formData.value.description) formData.value.description = preview.description;
                        if (!formData.value.image_url) formData.value.image_url = preview.image;
                        if (!formData.value.source) formData.value.source = preview.source;

                        // Llega en ISO; flatpickr y el backend esperan el día.
                        if (!formData.value.published_at && preview.publishedAt) {
                            formData.value.published_at = preview.publishedAt.slice(0, 10);
                        }

                        showToast('Datos del enlace cargados.', 'CheckIcon', 'success');
                        unlockFields();
                        fetching.value = false;

                    })
                    .catch(err => {
                        const message = err.response && err.response.data.message ? err.response.data.message : 'No se pudo leer el enlace.';
                        showToast(message, 'AlertTriangleIcon', 'danger');
                        unlockFields();
                        fetching.value = false;
                    });

            };

            const onSubmit = async () => {

                const isValid = await refForm.value.validate();

                if (!isValid) {
                    showToast('Complete los campos requeridos.', 'AlertTriangleIcon', 'warning');
                    return;
                }

                processing.value = true;

                store.dispatch('app-news/createNews', { payload: { ...formData.value } })
                    .then(response => {

                        showToast(response.data.message, 'CheckIcon', 'success');

                        setTimeout(() => {
                            router.push({ name: 'news' });
                        }, 1500);

                    })
                    .catch(err => {
                        const message = err.response && err.response.data.message ? err.response.data.message : 'Error al agregar la noticia.';
                        showToast(message, 'AlertTriangleIcon', 'danger');
                        processing.value = false;
                    });

            };

            return {
                processing,
                fetching,
                fieldsUnlocked,
                formData,
                dateConfig,
                refForm,

                fetchPreview,
                onSubmit
            }
        }
    }

</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
